import {Button, Group, Space} from "@mantine/core";
import QRCodeListView from "./list-view/QRCodeListView";
import classNames from "./QRCodeView.module.css";
import {IconPlus} from "@tabler/icons-react";
import {useNavigate} from "react-router-dom";
import QRCodeViewSorting from "./sorting/QRCodeViewSorting";

/**
 * Render list of QR codes with some extra components.
 * It's using QRCodeListView as a list.
 * @constructor
 */
function QRCodeView() {
    /**
     * Navigate function from react-router
     * @author Kacper Faber
     * @since 0.1.8
     */
    const navigate = useNavigate();

    /**
     * On the 'create' button is clicked.
     * Redirects to /qr-code/create
     * @author Kacper Faber
     * @since 0.1.7
     */
    const onCreateClick = () => {
        navigate('/qr-code/create');
    }

    return (
        <div>
            <Group justify="space-between" mb="md">
                <Space/>

                <Group>
                    <QRCodeViewSorting/>

                    <Button className={classNames.button} onClick={onCreateClick}>
                        <Group gap="xs">
                            <IconPlus/>

                            NOWY KOD QR
                        </Group>
                    </Button>
                </Group>
            </Group>

            <QRCodeListView/>
        </div>
    );
}

// noinspection JSUnusedGlobalSymbols
export default QRCodeView;

// TODO: QRCodeView.tsx
//  Implement hook to navigate only to valid pages.